const firebaseConfig = {
  apiKey: "AIzaSyBsLw2xlqYiP1qk8XVHolvbhqcX2eGN2Vo",
  authDomain: "tripstation-react.firebaseapp.com",
  projectId: "tripstation-react",
  storageBucket: "tripstation-react.appspot.com",
  messagingSenderId: "737962910199",
  appId: "1:737962910199:web:4ef6792207b6dbadc5cef2"
};
  export default firebaseConfig;